import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../modules/auth/services/auth.service';

@Injectable()
export class TokenInterceptService implements HttpInterceptor {

    constructor(private authService: AuthService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = `Bearer ${this.authService.getToken()}`;

        const request = req.clone({
            setHeaders: {
                Authorization: token
            }
        });


        return next.handle(request);
    }

}
